export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" />
    <path
      d="M11.0067 6.99992C11.0067 6.44764 11.4545 5.99992 12.0067 5.99992C12.5196 5.99992 12.9422 6.38596 13 6.8833L13.0067 6.99992L13 17C13 17.5523 12.5523 18 12 18C11.4871 18 11.0645 17.614 11.0067 17.1166L11 17L11.0067 6.99992Z"
      fill="currentColor"
    />
    <path
      d="M6.99992 12.9933C6.44764 12.9933 5.99992 12.5455 5.99992 11.9933C5.99992 11.4804 6.38596 11.0578 6.8833 11L6.99992 10.9933L17 11C17.5523 11 18 11.4477 18 12C18 12.5129 17.614 12.9355 17.1166 12.9933L17 13L6.99992 12.9933Z"
      fill="currentColor"
    />
  </svg>
);
